import { render, staticRenderFns } from "./VentilatorSettings.vue?vue&type=template&id=82a58d22"
import script from "./VentilatorSettings.vue?vue&type=script&lang=js"
export * from "./VentilatorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports